import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const WordPressGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copiedSpecific, setCopiedSpecific] = useState(false);
  const [copiedThemeEditor, setCopiedThemeEditor] = useState(false);
  const [copiedCustomize, setCopiedCustomize] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const fullCode = `<div id="chat-bot-container"></div>\n<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>`;

  const handleCopy = (text, setCopied) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to WordPress Website
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Looking for instructions on how to add your Ezzdesk widget to your WordPress website? Follow this simple guide to integrate it seamlessly.
      </p>

      <div style={{ background: '#edf7f6', border: '1px solid #dbe9e7', borderRadius: '10px', padding: '18px 20px', margin: '20px 0' }}>
        <div style={{ marginBottom: '20px' }}>
          <p style={{ margin: '0 0 8px 0' }}><strong>WordPress Plan</strong></p>
          <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>To install the widget, you need the <strong>Business or Commerce plan</strong> on WordPress. Free, Personal, and Premium plans don't support JavaScript, so the code will appear as plain text.</p>
        </div>
        <div style={{ paddingTop: '20px', borderTop: '1px solid #dbe9e7' }}>
          <p style={{ margin: '0 0 8px 0' }}><strong>WordPress Themes</strong></p>
          <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>WordPress offers Classic and Block themes. This guide focuses on <strong>Classic</strong> themes, but we’ll note when steps also apply to <strong>Block</strong> themes.</p>
        </div>
      </div>

      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#222' }}>Install on a Specific Page</h2>
        
        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '20px', fontSize: '14px' }}>
          These instructions apply to both <strong>Classic and Block</strong> themes.
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Access the WordPress Backend</strong><br/>
          Log in to your WordPress website backend and click on <strong>Pages</strong>. Find the needed page, hover over its title, and click <strong>Edit</strong>:
        </p>
        <img src="/assets/wordpress-1.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add the Code Block</strong><br/>
          In the editor, click the blue ➕ icon:
        </p>
        <img src="/assets/wordpress-2.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Find <strong>Custom HTML</strong> and drag and drop it to the spot where you'd like to display the widget:
        </p>
        <img src="/assets/wordpress-3.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the Installation Code</strong><br/>
          Paste your widget installation code in the <strong>HTML</strong> window and <strong>Save</strong> the changes:
        </p>
        
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedSpecific)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedSpecific ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/wordpress-4.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '50px' }}>
        <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#222' }}>Install on All Pages</h2>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '20px' }}>
          There are different methods for adding widgets to all pages depending on your theme. In this section, we’ll show you two options that work best for the <strong>Classic</strong> themes.
        </p>

        <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#444' }}>Method 1: Install via Theme Editor</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Access the WordPress Backend</strong><br/>
          Log in to your WordPress website backend. In the left-hand menu, select <strong>Appearance → Theme File Editor</strong>:
        </p>
        <img src="/assets/wordpress-5.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add the Installation Code</strong><br/>
          Choose <strong>Theme Footer (footer.php)</strong> in the right-hand menu of <strong>Theme Files</strong>. Insert the code before the closing <code>&lt;/body&gt;</code> tag, and click <strong>Update File</strong>:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedThemeEditor)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedThemeEditor ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/wordpress-6.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />



        <h3 style={{ fontSize: '20px', marginBottom: '15px', marginTop: '40px', color: '#444' }}>Method 2: Install via Customize Option</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Access the WordPress Backend</strong><br/>
          Log in to your WordPress website backend. Go to the <strong>Appearance</strong> tab in the left-hand menu and click <strong>Customize</strong>:
        </p>
        <img src="/assets/wordpress-7.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Add Custom HTML Element</strong><br/>
          Select <strong>Widgets</strong> in the left-hand menu:
        </p>
        <img src="/assets/wordpress-8.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Click the blue ➕ icon, then choose <strong>Custom HTML</strong>:
        </p>
        <img src="/assets/wordpress-9.jpg" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Paste the Installation Code</strong><br/>
          Paste your widget installation code into the <strong>HTML</strong> field and click <strong>Publish</strong> to apply the changes:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode, setCopiedCustomize)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copiedCustomize ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/wordpress-10.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

    </div>
  );
};

export default WordPressGuide;
